// Settings mutators — pure (state, args) => patch.

export function setSetting(state, { key, value }) {
  if (state.settings?.[key] === value) return null;
  return { settings: { ...state.settings, [key]: value } };
}
